import React from "react";
import {connect} from "react-redux";
import {get, objectToFormData} from '../../utils/api';
import Loading from '../Shared/Loading';
import AdminModal from '../Admin/Modal/AdminModal'
import moment from 'moment';
// import './user.css';
import SVG from 'react-inlinesvg';
import editPen from '../../assets/icons/edit.svg'
import Select from 'react-select';
import {updateUser, fetchUserRoles} from "../../actions/userActions";
import $ from "jquery";

class UsersRows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            title: false,
            showModal: {
                user: false,
                functionalities: false,
                verticals: false,
                subcategories: false,
                unpublished_mocks: false,
            },
            roles: {},
            userRole: ''
        };
        this.onEdit = this.onEdit.bind(this);
    }
    componentWillMount() {
        this.setState({roles: {
                id: this.props.user.id,
                label: this.props.user.role,
                value: this.props.user.role
            }})
    }
    onEdit(uid, key){
        this.setState({
            edit: true,
            title: key,
            showModal: {
                [key] : true
            }
        })
    }
    toggleModal = (show) => {
        this.setState({edit: show})
    }
    render(){
        const {user} = this.props;
        const {roles} = this.props;
        return(
            <tr>
                <td>{user.full_name !== null ? user.full_name : "" }</td>
                <td>{user.department !== null ? user.department : "Department"}</td>
                <td>{user.office !== null ? user.office : "New York"}</td>
                <td>{this.state.userRole ? this.state.userRole : user.role}</td>
                <td>{user.joined_on_date !== null ? moment(user.joined_on_date).format('MMMM Do, YYYY') : 'January 1st, 2022'}</td>
                <td>{user.last_login_date !== null ? moment(user.last_login_date).format('MMMM Do, YYYY') : 'January 1st, 2023'}</td>
                <td className={user.active ? 'active-status' : 'deactive-status'}>{user.active ? 'Active' : 'In active'}</td>
                <td>
                    <button className="button edit-btn"
                            onClick={() => this.onEdit(user.id, "user")}> <SVG src={editPen}></SVG>
                    </button>
                    {this.state.edit ? <AdminModal title={this.state.title} data={user} type={this.state.showModal} edit={this.state.edit} roles={roles} toggleModal={this.toggleModal} /> : ""}
                </td>
            </tr>
        )
    }
}
export default  connect(null)(UsersRows);